import { render, staticRenderFns } from "./GouvernanceView1.vue?vue&type=template&id=47c44ef6&"
import script from "./GouvernanceView1.vue?vue&type=script&lang=js&"
export * from "./GouvernanceView1.vue?vue&type=script&lang=js&"
import style0 from "./GouvernanceView1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports